/*
 *  Copyright (c) Qwoach LLC 2023. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 7/10/2023
 */

export const ProductTypeEnum = Object.freeze({
	SUBSCRIPTION: "SUBSCRIPTION",
	LIFETIME: "LIFETIME",
})
